import {
  EuiButtonEmpty,
  EuiButtonIcon,
  EuiCodeBlock,
  EuiFlexGroup,
  EuiFlexItem,
  EuiPanel,
  EuiSpacer,
  EuiText,
  EuiLink,
} from "@inscopix/ideas-eui";
import { useToolEditorContext } from "components/ToolEditor/Provider/ToolEditorProvider";
import { useLocalStorage } from "hooks/useLocalStorage";

export const ToolEditorFormCodeConfigInstructions = () => {
  const toolKey = useToolEditorContext((s) => s.tool.key);

  const [isConfigCollapsed, setIsConfigCollapsed] = useLocalStorage(
    "isx.ToolEditorConfigCollapsed",
    false,
  );

  const handleClickConfigExpandCollapse = () => {
    setIsConfigCollapsed((prev) => !prev);
  };

  return (
    <EuiPanel>
      <EuiFlexGroup gutterSize="xs" alignItems="center">
        <EuiFlexItem grow={false}>
          <EuiButtonIcon
            size="s"
            title={
              isConfigCollapsed
                ? "Show configuration instructions"
                : "Hide configuration instructions"
            }
            iconType={isConfigCollapsed ? "arrowRight" : "arrowDown"}
            onClick={handleClickConfigExpandCollapse}
          />
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
          <EuiButtonEmpty
            color="text"
            onClick={handleClickConfigExpandCollapse}
          >
            <EuiText size="s">
              <h3>
                Start by Configuring and Testing your Tool Locally with IDEAS
                CLI
              </h3>
            </EuiText>
          </EuiButtonEmpty>
        </EuiFlexItem>
      </EuiFlexGroup>
      {!isConfigCollapsed && (
        <>
          <EuiSpacer size="s" />
          <EuiText size="s">
            <p>
              <EuiLink
                target="_blank"
                href="https://inscopix.github.io/ideas-docs/custom_tools/user_guides/create_custom_tool.html#step-3a-configure-tool"
                rel="noopener noreferrer"
              >
                Configure your tool locally
              </EuiLink>{" "}
              for testing in your code directory. You will be prompted to enter
              some preliminary information about the tool. Follow the
              instructions to complete the configuration. This only needs to be
              done one time, when you first create a tool.
            </p>
          </EuiText>
          <EuiSpacer size="s" />
          <EuiCodeBlock language="shell" isCopyable paddingSize="m">
            {`ideas tools configure ${toolKey}`}
          </EuiCodeBlock>
          <EuiSpacer size="s" />
          <EuiText size="s">
            <p>
              <EuiLink
                target="_blank"
                href="https://inscopix.github.io/ideas-docs/custom_tools/user_guides/create_custom_tool.html#step-3b-run-tool"
                rel="noopener noreferrer"
              >
                Run your tool locally and validate execution and outputs.
              </EuiLink>{" "}
              You will be prompted to enter inputs to run the tool with locally.
              Follow the instructions in order to test the tool.
            </p>
          </EuiText>
          <EuiSpacer size="s" />
          <EuiCodeBlock language="shell" isCopyable paddingSize="m">
            {`ideas tools run ${toolKey}`}
          </EuiCodeBlock>
          <EuiSpacer size="s" />
          <EuiText size="s">
            <p>
              <EuiLink
                target="_blank"
                href="https://inscopix.github.io/ideas-docs/custom_tools/user_guides/create_custom_tool.html#step-3c-bundle-code"
                rel="noopener noreferrer"
              >
                Create a bundle of your local code and tool config
              </EuiLink>{" "}
              to upload to IDEAS.
            </p>
          </EuiText>
          <EuiSpacer size="s" />

          <EuiCodeBlock language="shell" isCopyable paddingSize="m">
            {`ideas tools bundle`}
          </EuiCodeBlock>
        </>
      )}
    </EuiPanel>
  );
};
